<template>
  <div>
    <b-modal
      v-model="modalStatus"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title">Add Funding</h5>
        <button type="button" class="close" @click="closeModal()">×</button>
      </template>
      <b-alert v-model="hasUnknownError" variant="danger" fade>
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>

      <div v-if="loadingCompanynames">
        <b-spinner small label="Small Spinner" type="grow"></b-spinner><small> Loading Data...</small>
      </div>

      <dx-autocomplete
        :data-source="companyNames"
        class="my-2"
        v-model="companySearch"
        :show-clear-button="true"
        :min-search-length="3"
        placeholder="Search by company name..."
        :onItemClick="searchByCompany"
        :disabled="loadingCompanynames"
      />

      <div v-if="loadingCompanies">
        <b-spinner small label="Small Spinner" type="grow"></b-spinner><small> Loading Companies...</small>
      </div>

      <dx-select-box
        v-if="filteredCompanies.length"
        :search-enabled="true"
        :data-source="filteredCompanies"
        display-expr="company"
        value-expr="field_001"
        class="mb-4"
        @value-changed="selectedValue"
        item-template="item"
      >
        <template #item="{ data }">
          <div>
            {{ data.company }} - {{ data.firstname }} {{ data.lastname }}
            <span v-if="data.profiles.length === 0" class="orange-highlight"> (no Business Profile)</span>
            <span v-if="data.profiles.length && data.profiles[0].cRMFundingProfileV2s.length" class="blue-highlight"> (existing Fundings)</span>
          </div>
        </template>
      </dx-select-box>

      <div class="mt-3">
        <small v-if="searchCompleted">No Profile or Company found?</small>
        <div class="btn-container">
          <b-button
            v-if="searchCompleted"
            variant="secondary"
            class="mt-1 mr-2"
            size="sm"
            @click="createProfile"
          >Create New
          </b-button>
          <b-button
            :disabled="disableBtn"
            variant="primary"
            class="mt-1 ok-btn"
            size="sm"
            @click="loadProfile"
          >Open Funding-Tab
          </b-button>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            hidden
          >
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { DxAutocomplete } from 'devextreme-vue/autocomplete'
  import DxSelectBox from 'devextreme-vue/select-box'
  export default {
    name: 'add-template',
    components: {
      DxSelectBox,
      DxAutocomplete
    },
    props: {
      template: Object
    },
    data () {
      return {
        isSubmitting: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        modalAlert: false,
        companySearch: '',
        loadingCompanies: false,
        disableBtn: true,
        selectedCompanyAddressId: null,
        filteredCompanies: [],
        searchCompleted: false,
        loadingCompanynames: false
      }
    },
    mounted () {
      this.$store.commit('fundings/SET_COMPANIES', [])
      this.filteredCompanies = []
      this.searchCompleted = false
      this.selectedCompanyAddressId = null
    },
    methods: {
      resetForm () {
        this.$store.commit('fundings/SET_COMPANIES', [])
        this.companySearch = ''
        this.filteredCompanies = []
        this.searchCompleted = false
        this.selectedCompanyAddressId = null
        if (this.companyNames.length < 1) {
          this.loadingCompanynames = true
          this.onGetCompanyNames()
        }
      },
      searchByCompany () {
        if (this.companySearch !== '') {
          this.getCompanies()
        }
      },
      selectedValue (val) {
        this.selectedCompanyAddressId = val.value
        this.disableBtn = false
      },
      loadProfile () {
        window.open(`https://crm.ifj.ch/index.cfm?page=137659&crm_adresse_id=${this.selectedCompanyAddressId}&ShowTab=FundingAddTab#detailTabsAnchor`, '_blank')
      },
      createProfile () {
        window.open('https://crm.ifj.ch/index.cfm?page=115963', '_blank')
      },
      async getCompanies () {
        this.$store.commit('fundings/SET_COMPANIES', [])
        this.loadingCompanies = true
        try {
          const { errors } = await this.$store.dispatch('fundings/GET_COMPANIES', this.companySearch)
          if (errors) throw errors
          else {
            this.loadingCompanies = false
            this.filteredCompanies = this.nonNullItems()
            this.searchCompleted = true
          }
        } catch (err) {
          this.hasError = true
          this.loadingCompanies = false
          this.searchCompleted = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      async onGetCompanyNames () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('fundings/GET_COMPANY_NAMES')
          if (errors) throw errors
          this.loadingCompanynames = false
        } catch (err) {
          this.hasError = true
          this.loadingCompanynames = false
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          this.loadingShow = false
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      },
      nonNullItems () {
        return this.allCompanies.filter(function (item) {
          return item.cRMAdresseJOINRolles.length > 0
        })
      },
      closeModal () {
        this.$store.commit('fundings/SET_ADD_FUNDINGMODAL_STATUS', false)
      }
    },
    computed: {
      ...mapGetters({
        allCompanies: 'fundings/COMPANIES',
        companyNames: 'fundings/COMPANYNAMES'
      }),
      ...mapState({
        modalStatus: state => state.fundings.addFundingModal
      })
    }
  }
</script>
<style lang="scss">
.btn-container {
  display: flex;

  .ok-btn {
    margin-left: auto;
    margin-right: 0;
  }
}

.blue-highlight {
  color: #007bff;
}

.orange-highlight {
  color: orangered;
}
</style>
